import { FC, useState } from 'react';
import { useBenefits } from 'store/benefits';
import { SelectFilter, SelectFilterProps } from 'components/filters';
import { Binary } from 'types/Common';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
> & { showArchived?: Binary | null };

export const BenefitsFilter: FC<Props> = ({ showArchived, ...props }) => {
  const [search, setSearch] = useState('');

  const { data: benefits, isLoading } = useBenefits({
    name: [search],
    showArchived,
  });

  return (
    <SelectFilter
      {...props}
      options={benefits?.items.map((benefit) => ({
        key: benefit.id,
        label: benefit.name,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      multiple
      asyncSearch
    />
  );
};
